var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApiLoadingController',{attrs:{"fetch":_vm.fetch,"params":_vm.teamId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('TeamMain',_vm._b({},'TeamMain',data,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }